<div class="session-timer-container">
  <mat-icon class="time-icon">access_time</mat-icon>
  <div class="progress-container">
    <span class="session-time">Tempo da sessão: {{ formattedTime }}</span>
    <mat-progress-bar class="time-bar" mode="determinate" [value]="progressPercentage"></mat-progress-bar>
  </div>
</div>
